<template>
  <div v-loading="loadingUserScope" class="govgr-card">
    <el-row>
      <el-col :xs="20" :sm="16" :md="14" :lg="10" :xl="8">
        <el-card shadow="hover" class="govgr-card govgr-card__body box-card">
          <div slot="header" class="clearfix">
            <h3 align="center">Είσοδος στο eDoatap</h3>
          </div>
          <div class="text item">
            <el-form
              v-if="authStep === 'credentials'"
              ref="loginForm"
              :model="loginForm"
              :rules="validationRules"
              label-width="80px"
              class="ruleForm"
              autocomplete="on"
              @submit.native.prevent
              @keydown.enter.native.prevent="login"
            >
              <el-form-item label="Όνομα" prop="email">
                <el-input v-model="loginForm.email" type="text" name="username" id="username" auto-complete="username" />
              </el-form-item>
              <el-form-item label="Κωδικός" prop="password">
                <div class="password-wrapper">
                  <el-input
                    v-model="loginForm.password"
                    :type="showPassword ? 'text' : 'password'"
                    name="current-password"
                    id="current-password"
                    auto-complete="current-password"
                  />
                  <span class="password-toggle-icon" @click="showPassword = !showPassword">
                    <svg v-if="showPassword" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                      <line x1="1" y1="1" x2="23" y2="23"/>
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                  </span>
                </div>
              </el-form-item>
              <el-form-item>
                <el-button id="loginSubmit" type="primary" @click="login">Υποβολή</el-button>
                <el-button @click="resetForm('loginForm')">Σβήσιμο</el-button>
              </el-form-item>
            </el-form>
            <el-form
              v-else-if="authStep === 'otp'"
              ref="otpForm"
              :model="otpForm"
              :rules="otpValidationRules"
              label-width="80px"
              class="ruleForm otp-form"
              autocomplete="off"
              @submit.native.prevent
            >
              <el-form-item class="otp-top-message-item">
                <div class="otp-message">
                  <span v-if="otpEmailMasked">Έχει σταλεί κωδικός OTP στο email {{ otpEmailMasked }}.</span>
                  <span v-else>Έχει σταλεί κωδικός OTP στο email σας.</span>
                </div>
              </el-form-item>
              <el-form-item label="OTP" prop="otp">
                <el-input
                  v-model="otpForm.otp"
                  type="text"
                  name="one-time-code"
                  id="one-time-code"
                  auto-complete="one-time-code"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  maxlength="6"
                  v-on:keydown.enter.native.prevent="verifyOtp"
                />
              </el-form-item>
              <el-form-item class="otp-actions-item">
                <div class="otp-actions">
                  <el-button id="otpSubmit" type="primary" @click="verifyOtp">Επιβεβαίωση</el-button>
                  <el-button @click="backToCredentials">Επιστροφή</el-button>
                  <el-button :disabled="resendDisabled" @click="resendOtp">
                    <span v-if="resendDisabled">Επαναποστολή OTP ({{ resendCountdownText }})</span>
                    <span v-else>Επαναποστολή OTP</span>
                  </el-button>
                </div>
              </el-form-item>
            </el-form>
            <el-form
              v-else-if="authStep === 'role'"
              ref="roleForm"
              label-width="80px"
              class="ruleForm"
              @submit.native.prevent
            >
              <el-form-item label="Ρόλος">
                <el-select v-model="role" placeholder="Πιέστε για επιλογή" id="selectRole">
                  <el-option
                    v-for="(role, index) in userScope"
                    :key="role"
                    :label="userScopeGr[index]"
                    :value="role"
                    v-on:keydown.enter.native.prevent="selectedRole(role)"
                  />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button id="roleSelect" type="primary" @click="selectedRole(role)">Επιλογή Ρόλου</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  data () {
    return {
      loginForm: {
        email: '',
        password: ''
      },
      otpForm: {
        otp: ''
      },
      validationRules: {
        email: [
          { required: true, message: 'Το όνομα χρήστη είναι υποχρεωτικό', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Ο κωδικός είναι υποχρεωτικός', trigger: 'blur' }
        ]
      },
      otpValidationRules: {
        otp: [
          { required: true, message: 'Ο κωδικός OTP είναι υποχρεωτικός', trigger: 'blur' }
        ]
      },
      role: null,
      error: false,
      showPassword: false,
      authStep: 'credentials',
      otpExpiresAt: null,
      otpCountdownSeconds: 0,
      otpTimerInterval: null,
      otpEmailMasked: null
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      userScope: 'userScope',
      userScopeGr: 'userScopeGr',
      loadingUserScope: 'loadingUserScope'
    }),
    resendDisabled () {
      return this.otpCountdownSeconds > 0
    },
    resendCountdownText () {
      return this.formatSeconds(this.otpCountdownSeconds)
    }
  },
  methods: {
    focusOtpInput () {
      this.$nextTick(() => {
        const otpInput = document.getElementById('one-time-code')
        if (otpInput) otpInput.focus()
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.loginForm.email = ''
      this.loginForm.password = ''
      this.showPassword = false
    },
    resetOtpForm () {
      this.otpForm.otp = ''
      this.$nextTick(() => {
        if (this.$refs.otpForm) {
          this.$refs.otpForm.clearValidate()
        }
      })
    },
    clearOtpTimer () {
      if (this.otpTimerInterval) {
        clearInterval(this.otpTimerInterval)
        this.otpTimerInterval = null
      }
    },
    formatSeconds (seconds) {
      const safeSeconds = Math.max(0, Number(seconds) || 0)
      const minutes = Math.floor(safeSeconds / 60)
      const remainingSeconds = safeSeconds % 60
      const formattedMinutes = String(minutes).padStart(2, '0')
      const formattedSeconds = String(remainingSeconds).padStart(2, '0')
      return `${formattedMinutes}:${formattedSeconds}`
    },
    startOtpTimer () {
      this.clearOtpTimer()
      if (this.otpCountdownSeconds <= 0) return
      this.otpTimerInterval = setInterval(() => {
        if (this.otpCountdownSeconds > 0) {
          this.otpCountdownSeconds--
        } else {
          this.clearOtpTimer()
        }
      }, 1000)
    },
    setOtpState (response) {
      this.otpExpiresAt = response.otpExpiresAt || null
      this.otpCountdownSeconds = Number(response.otpCountdownSeconds) || 0
      this.otpEmailMasked = response.emailMasked || null
      this.startOtpTimer()
    },
    clearOtpUiState () {
      this.clearOtpTimer()
      this.otpExpiresAt = null
      this.otpCountdownSeconds = 0
      this.otpEmailMasked = null
    },
    backToCredentials () {
      this.$store.dispatch('clearLoginMFA')
      this.clearOtpUiState()
      this.otpForm.otp = ''
      this.authStep = 'credentials'
      this.$nextTick(() => {
        if (this.$refs.otpForm) {
          this.$refs.otpForm.clearValidate()
        }
        if (this.$refs.loginForm) {
          this.$refs.loginForm.clearValidate()
        }
      })
    },
    storeBrowserCredentials () {
      if (window.PasswordCredential && navigator.credentials && this.loginForm.email && this.loginForm.password) {
        const form = document.createElement('form')
        const usernameInput = document.createElement('input')
        usernameInput.type = 'text'
        usernameInput.name = 'username'
        usernameInput.value = this.loginForm.email
        const passwordInput = document.createElement('input')
        passwordInput.type = 'password'
        passwordInput.name = 'password'
        passwordInput.value = this.loginForm.password
        form.appendChild(usernameInput)
        form.appendChild(passwordInput)
        try {
          const credential = new window.PasswordCredential(form)
          navigator.credentials.store(credential).catch(() => {})
        } catch (e) {
        }
      }
    },
    selectedRole (role) {
      const noChatroomsRoles = [
        'Auditor',
        'TemporaryUser',
        'DocutracksUser',
        'CouncilMember',
        'SpecialReappraisalBoardMember'
      ]
      const externalChatroomsRoles = ['SpecialProponent', 'PreChecker']
      if (role !== null) this.$store.dispatch('selectedRole', role)
      if (!noChatroomsRoles.includes(role)) this.$store.dispatch('GET_CHATROOMS')
      if (externalChatroomsRoles.includes(role)) this.$store.dispatch('GET_EXTERNAL_CHATROOMS')
    },
    login () {
      this.$refs.loginForm.validate((valid) => {
        if (!valid) return false
        this.$store.dispatch('loginMFA', {
          name: this.loginForm.email,
          password: this.loginForm.password
        }).then((response) => {
          if (!response) return
          if (response.directLogin) {
            this.authStep = 'role'
            return
          }
          if (response.success && response.otpActive) {
            this.setOtpState(response)
            this.authStep = 'otp'
            this.$nextTick(() => {
              if (this.$refs.otpForm) {
                this.$refs.otpForm.clearValidate()
              }
            })
            this.focusOtpInput()
          }
        })
      })
    },
    resendOtp () {
      if (this.resendDisabled) return
      this.otpForm.otp = ''
      this.$nextTick(() => {
        if (this.$refs.otpForm) {
          this.$refs.otpForm.clearValidate()
        }
      })
      this.$store.dispatch('loginMFA', {
        name: this.loginForm.email,
        password: this.loginForm.password
      }).then((response) => {
        if (response && response.success && response.otpActive) {
          this.setOtpState(response)
          this.focusOtpInput()
        }
      })
    },
    verifyOtp () {
      this.$refs.otpForm.validate((valid) => {
        if (!valid) {
          this.focusOtpInput()
          return false
        }
        this.$store.dispatch('verifyLoginMFA', {
          otp: this.otpForm.otp
        }).then((response) => {
          if (response && response.success) {
            this.storeBrowserCredentials()
            this.clearOtpUiState()
            this.resetOtpForm()
            this.authStep = 'role'
          }
        })
      })
    }
  },
  watch: {
    userScope (value) {
      if (value && value.length > 0) {
        this.authStep = 'role'
      }
    }
  },
  beforeDestroy () {
    this.clearOtpTimer()
  }
}
</script>

<style lang="scss" scoped>
.govgr-card {
  background: #ffffff;
  padding: 40px 16px;
}

.el-card {
  background-color: #f5f7fa;
  color: #1d2a3b;
  border: 1px solid #d9e1e8;
  box-shadow: 0 2px 8px rgba(0, 51, 117, 0.08);
}

.el-card__body {
  padding: 24px;
}

.el-row {
  display: flex;
  justify-content: center;
  margin: 0;
}

.bg-purple {
  background: #d3dce6;
}

body {
  background: #ffffff;
}

.login-wrapper {
  background: #fff;
  width: 70%;
  margin: 12% auto;
}

.otp-message {
  text-align: center;
  color: #1d2a3b;
  margin-bottom: 8px;
  line-height: 1.5;
}

.clearfix h3 {
  color: #003375;
  font-weight: 600;
}

.otp-form {
  margin: 0;
}

.otp-top-message-item {
  margin-bottom: 18px;
}

.otp-actions {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
}

.otp-actions .el-button {
  margin-left: 0 !important;
}

.password-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-toggle-icon {
  position: absolute;
  right: 10px;
  cursor: pointer;
  color: #8a99ab;
  font-size: 16px;
  z-index: 1;
  &:hover {
    color: #1d2a3b;
  }
}

::v-deep .el-form-item__label {
  color: #1d2a3b;
  font-weight: 500;
}

::v-deep .el-input__inner {
  background-color: #ffffff;
  border: 1px solid #8a99ab;
  color: #1d2a3b;
}

::v-deep .el-input__inner::placeholder {
  color: #6b7785;
}

::v-deep .el-input__inner:focus {
  border-color: #fbc02d;
  box-shadow: 0 0 0 3px rgba(251, 192, 45, 0.35);
}

::v-deep .el-button--primary {
  background-color: #00703c;
  border-color: #00703c;
}

::v-deep .el-button--primary:hover,
::v-deep .el-button--primary:focus {
  background-color: #005f33;
  border-color: #005f33;
}

::v-deep .el-form-item.is-error .el-input__inner {
  border-color: #b10e1e;
  background-color: #fff5f5;
}

::v-deep .el-form-item__error {
  color: #b10e1e;
  font-weight: 600;
  line-height: 1.4;
  padding-top: 6px;
}

::v-deep .el-form-item.is-error .el-input__inner:focus {
  border-color: #b10e1e;
  box-shadow: 0 0 0 3px rgba(177, 14, 30, 0.2);
}

::v-deep .el-select .el-input.is-focus .el-input__inner {
  border-color: #fbc02d;
  box-shadow: 0 0 0 3px rgba(251, 192, 45, 0.35);
}

::v-deep .el-select .el-input__inner {
  border: 1px solid #8a99ab;
  color: #1d2a3b;
  background-color: #ffffff;
}

@media (max-width: 768px) {
  .govgr-card {
    padding: 24px 12px;
  }

  .el-card__body {
    padding: 16px;
  }

  .otp-actions {
    flex-wrap: wrap;
  }
}
</style>

<style lang="scss">
.el-notification {
  z-index: 3000 !important;
}

.el-notification.right {
  right: 16px !important;
}

.el-notification__group {
  margin: 0;
}

#current-password {
  padding-right: 36px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue